<template>
  <div>
    <div class="text-center">
      <div class="excludeArea">
        <img src="../../assets/image/user-journey/should_exclude.svg" alt="">
        <div class="description mt-5">
          با توجه به وضعیتی که شرح دادید و همچنین محدودیت پلتفرم های آنلاین،در حال حاضر بهترین انتخاب برای شما دریافت
          کمک
          حضوری است.
        </div>
        <div class="description mt-3">
          در صورتی که در این زمینه نیاز به راهنمایی دارید، میتوانید به لینک زیر مراجعه کنید.
        </div>
        <a href="https://simiaroom.com/%D8%AA%D9%84%D9%81%D9%86-%D9%87%D8%A7%DB%8C-%D8%A7%D9%88%D8%B1%DA%98%D8%A7%D9%86%D8%B3%DB%8C-%D8%AD%D9%88%D8%B2%D9%87-%D8%B3%D9%84%D8%A7%D9%85%D8%AA-%D8%B1%D9%88%D8%A7%D9%86/">
          <v-btn
              outlined
              color="primary"
              class="submitBtnOutline mt-10"
              elevation="0"
          >
            تلفن های اورژانسی حوزه سلامت روان
          </v-btn>
        </a>
        <v-btn
            @click="resetJourney"
            text
            color="primary"
            style="background: #f0faf6"
            class="submitBtnOutline mt-4"
            elevation="0"
        >
          شروع دوباره
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import {clearJourneyStorage} from "@/utils/journeyToken";

export default {
  data() {
    return {}
  },
  beforeDestroy() {
    // this.$emitEvent('changeVisibiltySeekback', true)
  },
  methods: {
    resetJourney() {
      clearJourneyStorage()
      setTimeout(() => {
        location.reload();
      }, 500)
    }
  },
  mounted() {
    this.$emitEvent('changeVisibiltySeekback', false)
  },

}
</script>

<style lang="scss" scoped>
@media (min-width: 200px) and (max-width: 800px) {
  .excludeArea {
    width: 100% !important;
    padding: 20px;
  }
}

.excludeArea {
  width: 40%;
  margin: 0px auto;
}

.description {
  color: #212121;
  text-align: right;
  font-size: var(--Font-Size-2xl, 20px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.submitBtnOutline {
  border-radius: 8px;
  width: 100%;
  height: 48px !important;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 45px;
}
</style>